import { obtenerSolicitudTipoId, SolicitudTiposEnum } from "./solicitud-tipos.enum";

export const mapearASolicitudDocumentos = (
  solicitudTipo: SolicitudTiposEnum,
  documentosFormulario: object,
  acreditaCM = false,
  crearComplementoVacio = false
): Array<any> => {
  if (!documentosFormulario) {
    return [];
  }
  const complementos: any = [];
  if (crearComplementoVacio && (!documentosFormulario || Object.keys(documentosFormulario).length === 0)) {
    const complementoVacio = {};
    complementoVacio[solicitudTipo] = [];
    complementos.push(complementoVacio);
    return complementos;
  }


  const documentosItems = Object.keys(documentosFormulario);

  if (acreditaCM) {
    const acm = {};
    acm[SolicitudTiposEnum.ACM] = [];
    complementos.push(acm);
  }

  documentosItems.forEach((key) => {
    const documentoFormulario = documentosFormulario[key];
    const documento = {
      ...documentoFormulario,
      idDocumento: key,
      nombre: documentoFormulario.nameFile,
      idTipoDocumento: documentoFormulario.idForm,
    };
    delete documento.nameFile;
    delete documento.idForm;

    const esDocumentoDeCuotaMonetaria = key === "certificadoEscolar";

    if (esDocumentoDeCuotaMonetaria) {
      let acm = complementos.find((c) => c[SolicitudTiposEnum.ACM]);
      acm.ACM.push(documento);
    } else {
      let afi = complementos.find((c) => c[solicitudTipo]);
      if (!afi) {
        afi = {};
        afi[solicitudTipo] = [];
        complementos.push(afi);
      }
      afi[solicitudTipo].push(documento);
    }
  });

  return complementos;
};

export const agregarDocumentoRNEC = (
  solicitudTipo: SolicitudTiposEnum,
  documentoRNECB64: string,
  complementos: Array<any>,
  esRnecParentesco = false
) => {
  if (!documentoRNECB64) return;

  const nuevoDocumento = {
    idTipoDocumentoDigital: esRnecParentesco ? 18 : 16,
    base64: documentoRNECB64,
    revisionManual: false,
    pathDocumentoDigital: "",
    esDocumentoDigital: false,
    idDocumento: esRnecParentesco ? "docRnecHijo" : "rnec",
    nombre: esRnecParentesco ? "rnecHijo.pdf" : "soporte_digital_RNEC.pdf",
    idTipoDocumento: esRnecParentesco ? 18 : 16,
    idTipoTransaccion: obtenerSolicitudTipoId(solicitudTipo),
  };

  let afi = complementos.find((c) => c[solicitudTipo]);
  if (!afi) {
    afi = {};
    afi[solicitudTipo] = [];
    complementos.push(afi);
  }

  afi[solicitudTipo].push(nuevoDocumento);
};

export const agregarDocumentosNoExigibles = (
  solicitudTipo: SolicitudTiposEnum,
  documentos: Array<any>,
  complementos: Array<any>
) => {
  if (!documentos) return;

  documentos.forEach((documentoAfiliado) => {
    const documentoTransformado = {
      idTipoDocumentoDigital: documentoAfiliado.idTipoDocumento,
      base64: "",
      revisionManual: false,
      pathDocumentoDigital: documentoAfiliado.nombre,
      idTipoTransaccion: 0,
      esDocumentoDigital: true,
      idDocumento: documentoAfiliado.idForm,
      nombre: documentoAfiliado.label,
      idTipoDocumento: documentoAfiliado.idTipoDocumento,
    };

    let afi = complementos.find((c) => c[solicitudTipo]);
    if (!afi) {
      afi = {};
      afi[solicitudTipo] = [];
      complementos.push(afi);
    }

    afi[solicitudTipo].push(documentoTransformado);
  });
};
